import React, { useState } from 'react';
import { useDemo } from '../../context/DemoContext';
import { BadgeInfo, ChevronDown, Eye, EyeOff } from 'lucide-react';

// Expandable rationale note shown only when the Investor Overlay is ON
export function InvestorNote({ id, title, children, className = '' }) {
  const { investorMode } = useDemo();
  const [open, setOpen] = useState(false);
  if (!investorMode) return null;
  return (
    <div data-testid={`investor-note-${id}`} className={`inline-block max-w-xl ${className}`}>
      <button
        data-testid={`investor-note-toggle-${id}`}
        onClick={() => setOpen((v) => !v)}
        className="flex items-center gap-2 rounded-lg px-3 py-1.5 text-left transition-colors"
        style={{ border: '1px dashed rgba(176,38,255,0.45)', background: open ? 'rgba(176,38,255,0.10)' : 'rgba(176,38,255,0.05)' }}
      >
        <BadgeInfo className="h-3.5 w-3.5 text-[#B026FF] flex-shrink-0" />
        <span className="text-[10px] font-600 tracking-[0.18em] uppercase text-[#B026FF]">Investor Note</span>
        <span className="text-xs text-white/70 font-500">{title}</span>
        <ChevronDown className={`h-3.5 w-3.5 text-white/40 transition-transform ${open ? 'rotate-180' : ''}`} />
      </button>
      {open && (
        <div data-testid={`investor-note-body-${id}`} className="mt-1.5 rounded-lg px-4 py-3 text-[13px] leading-relaxed text-white/65 xc-fade-up"
          style={{ border: '1px dashed rgba(176,38,255,0.3)', background: 'rgba(176,38,255,0.05)' }}>
          {children}
        </div>
      )}
    </div>
  );
}

// Floating site-wide toggle (fixed bottom-right)
export function InvestorToggle() {
  const { investorMode, toggleInvestorMode } = useDemo();
  return (
    <button
      data-testid="investor-overlay-toggle"
      onClick={toggleInvestorMode}
      title={investorMode ? 'Switch to pure player experience' : 'Show investor rationale notes'}
      className="fixed bottom-5 right-5 z-40 flex items-center gap-2.5 rounded-full pl-4 pr-2 py-2 xc-glass transition-all"
      style={{
        border: investorMode ? '1px solid rgba(176,38,255,0.55)' : '1px solid rgba(255,255,255,0.12)',
        boxShadow: investorMode ? '0 0 24px rgba(176,38,255,0.35)' : 'none',
      }}
    >
      {investorMode ? <Eye className="h-4 w-4 text-[#B026FF]" /> : <EyeOff className="h-4 w-4 text-white/40" />}
      <span className={`text-[11px] font-600 tracking-[0.14em] uppercase ${investorMode ? 'text-white/90' : 'text-white/45'}`}>Investor Overlay</span>
      <span className="text-[10px] font-700 tracking-wider rounded-full px-2.5 py-1"
        style={investorMode
          ? { background: 'linear-gradient(135deg,#D90035,#7A18FF)', color: '#fff' }
          : { background: 'rgba(255,255,255,0.08)', color: 'rgba(255,255,255,0.5)' }}>
        {investorMode ? 'ON' : 'OFF'}
      </span>
    </button>
  );
}
